const olderInstallNewApp = (preview, setDownloadStatus) => {
  let HisenseBrowserObject = window.HiBrowser; // расширенное API на браузерах, там пустой объект
  let currentDate = new Date();
  let canDownload = false;

  HisenseBrowserObject.loadLibrary("libhspdk-jsx.so"); // становится не пустым

  let newApp = {
    StartCommand: "https://tv.tvoe.live?installed=vidaa",
    URL: "https://tv.tvoe.live?installed=vidaa",
    InstallTime:
      currentDate.getFullYear() +
      "-" +
      (currentDate.getMonth() + 1) +
      "-" +
      currentDate.getDate(),
    AppId: "TVOЁ_debug",
    Icon_96: preview,
    IconURL: preview,
    Thumb: preview,
    Image: preview,
    AppName: "TVOЁ",
    Title: "TVOЁ",
    RunTimes: 0,
    StoreType: "store",
    PreInstall: false,
  };

  let installAppObj, presetAppObj;
  let installedAppJsonStr = HisenseBrowserObject.File.read(
    "launcher/Appinfo.json",
    1
  );
  let presetAppJsonStr = HisenseBrowserObject.File.read(
    "launcher/preset.txt",
    1
  );

  if (installedAppJsonStr) {
    try {
      presetAppObj = eval("(" + installedAppJsonStr + ")");
    } catch (e) {
      presetAppObj = 0;
    }
    installAppObj = presetAppObj;
  } else {
    installAppObj = 0;
  }

  if (presetAppJsonStr) {
    try {
      presetAppObj = eval("(" + presetAppJsonStr + ")");
    } catch (e) {
      presetAppObj = 0;
    }
    presetAppObj = eval("(" + presetAppJsonStr + ")");
  } else {
    presetAppObj = 0;
  }
  let installed = 0;

  function checkArrayItemExist(array, item) {
    if (!array || !Array.isArray(array)) {
      return 0;
    }

    let count;
    for (count = 0; count < array.length; count++) {
      if (
        item.AppName.toLowerCase() === array[count].AppName.toLowerCase() ||
        item.URL === array[count].StartCommand
      ) {
        break;
      }
    }
    if (count === array.length) {
      return 0;
    } else {
      return 1;
    }
  }

  if (presetAppObj) {
    installed = checkArrayItemExist(presetAppObj.AppInfo, newApp);
  }

  if (installAppObj && !installed) {
    if (!checkArrayItemExist(installAppObj.AppInfo, newApp)) {
      installAppObj.AppInfo.push(newApp);
      canDownload = true;
    }
  } else if (!installAppObj && !installed) {
    var newAppJsonStr = '{"AppInfo":[' + JSON.stringify(newApp) + "]}";
    installAppObj = eval("(" + newAppJsonStr + ")");
    canDownload = true;
  }

  if (canDownload) {
    var writedata = JSON.stringify(installAppObj);
    HisenseBrowserObject.File.write("launcher/Appinfo.json", writedata, 1);
    setDownloadStatus("Success");
  } else {
    setDownloadStatus("AlreadyInstalled");
  }
};

export default olderInstallNewApp;
